<template>
    <div class="rank-card">
        <div class="rank-card-title">{{ title }}</div>
        <div ref="list" class="rank-list" :class="{ 'rank-list--scroll': scrollable }">
            <div v-for="item in items" :key="item.id" class="rank-row" :class="{ highlight: item.highlight }">
                <span class="rank-name">{{ item.name }}</span>
                <div class="rank-track">
                    <span class="rank-tick" style="left:25%" />
                    <span class="rank-tick" style="left:50%" />
                    <span class="rank-tick" style="left:75%" />
                    <div class="rank-fill" :style="{ width: fillWidth(item) }" />
                </div>
                <span class="rank-value">{{ item.label }}</span>
            </div>
            <div v-if="items.length === 0" class="rank-empty">{{ emptyText || $t('common.without_data') }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RankList",
    props: {
        title: {
            type: String,
            default: '',
        },
        items: {
            type: Array,
            default: () => [],
        },
        emptyText: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            scrollable: false,
        }
    },
    mounted() {
        this.checkScroll()
    },
    updated() {
        this.checkScroll()
    },
    methods: {
        checkScroll() {
            const el = this.$refs.list
            this.scrollable = !!el && el.scrollHeight > el.clientHeight
        },
        fillWidth(item) {
            const max = Number(item.max || 0)
            if (max <= 0) return '0%'
            const percent = Math.min(100, Math.max(0, (Number(item.value || 0) / max) * 100))
            return `${percent}%`
        },
    },
}
</script>

<style scoped>
.rank-card {
    background: var(--v-surface2-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 12px;
    padding: 14px 16px;
}

.rank-card-title {
    font-size: 10px;
    font-weight: 700;
    color: var(--v-txtMuted-base);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-bottom: 12px;
}

.rank-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 230px;
    overflow-y: auto;
}

.rank-list--scroll {
    padding-right: 10px;
}

.rank-list::-webkit-scrollbar {
    width: 5px;
}

.rank-list::-webkit-scrollbar-track {
    background: transparent;
}

.rank-list::-webkit-scrollbar-thumb {
    background: var(--v-outline2-base);
    border-radius: 3px;
}

.rank-row {
    display: grid;
    grid-template-columns: 74px 1fr 48px;
    align-items: center;
    gap: 10px;
}

.rank-name {
    font-size: 12px;
    color: var(--v-txtSecondary-base);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.rank-row.highlight .rank-name {
    color: var(--v-secondary-base);
    font-weight: 700;
}

.rank-track {
    position: relative;
    height: 18px;
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 9px;
    overflow: hidden;
}

.rank-fill {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    background: var(--v-outline2-base);
    border-radius: 9px 0 0 9px;
}

.rank-row.highlight .rank-fill {
    background: linear-gradient(90deg, rgba(51, 153, 153, 0.65), rgba(102, 204, 204, 0.4));
}

.rank-tick {
    position: absolute;
    top: 2px;
    bottom: 2px;
    width: 1px;
    background-image: linear-gradient(var(--v-outline2-base) 60%, transparent 0%);
    background-size: 1px 5px;
    opacity: 0.8;
}

.rank-value {
    font-size: 11px;
    font-weight: 700;
    color: var(--v-txtMuted-base);
    text-align: right;
}

.rank-row.highlight .rank-value {
    color: var(--v-secondary-base);
}

.rank-empty {
    font-size: 12px;
    color: var(--v-txtMuted-base);
    font-style: italic;
    padding: 8px 0;
}
</style>
